import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: `${API_URL}/tasks`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const taskService = {
  // Projects
  listProjects: async () => (await api.get('/projects')).data,
  createProject: async (data) => (await api.post('/projects', data)).data,
  updateProject: async (id, data) => (await api.put(`/projects/${id}`, data)).data,
  addProjectMember: async (id, userId, role='contributor') => (await api.post(`/projects/${id}/members`, { userId, role })).data,
  removeProjectMember: async (id, userId) => (await api.delete(`/projects/${id}/members/${userId}`)).data,
  listProjectFiles: async (id) => (await api.get(`/projects/${id}/files`)).data,
  uploadProjectFile: async (id, file) => {
    const form = new FormData(); form.append('file', file);
    return (await api.post(`/projects/${id}/files`, form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },

  // Tasks
  listTasks: async (params={}) => (await api.get('/', { params })).data,
  createTask: async (data) => (await api.post('/', data)).data,
  updateTask: async (id, data) => (await api.put(`/${id}`, data)).data,
  deleteTask: async (id) => (await api.delete(`/${id}`)).data,
  getComments: async (id) => (await api.get(`/${id}/comments`)).data,
  addComment: async (id, comment) => (await api.post(`/${id}/comments`, { comment })).data,
  uploadAttachment: async (id, file) => {
    const form = new FormData(); form.append('file', file);
    return (await api.post(`/${id}/attachments`, form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },
};

export default taskService;


